import script from "./TrackersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrackersList.vue?vue&type=script&lang=ts&setup=true"

import "./TrackersList.vue?vue&type=style&index=0&id=54d9e4b6&lang=sass"

const __exports__ = script;

export default __exports__